import api from '../api';

export const createAuthHandoff = (targetOrigin) =>
  api.post('/auth/handoff/create', { targetOrigin }).then((response) => response.data);

export const exchangeAuthHandoff = (code, targetOrigin) =>
  api.post('/auth/handoff/exchange', { code, targetOrigin }).then((response) => response.data);
